import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMap = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.7 3.73C18.22 3.46 18.79 3.49 19.25 3.77H19.24C19.71 4.06 19.99 4.56 19.99 5.12V17.08C19.99 17.7 19.65 18.29 19.13 18.55L15.26 20.81C15.26 20.82 15.24 20.82 15.24 20.82C15.02 20.93 14.78 20.99 14.54 20.99H14.5C14.49 20.99 14.48 20.9875 14.47 20.985C14.46 20.9825 14.45 20.98 14.44 20.98C14.24 20.97 14.03 20.93 13.84 20.83L9.73 18.42C9.6 18.35 9.42 18.35 9.26 18.43L6.3 20.26C5.78 20.53 5.21 20.5 4.75 20.22C4.28 19.93 4 19.43 4 18.87V6.9C4 6.3 4.33 5.76 4.86 5.49L8.78 3.17C8.99 3.06 9.22 3 9.45 3H9.53C9.76 3 10 3.05 10.21 3.16L14.32 5.57C14.45 5.64 14.64 5.64 14.79 5.56L17.7 3.73ZM5.27 19.38C5.44 19.48 5.63 19.49 5.81 19.4L8.77 17.57C8.82743 17.5413 8.8797 17.5229 8.93422 17.5037C8.95565 17.4961 8.97743 17.4885 9 17.48V4.21L5.34 6.38C5.12 6.49 5 6.69 5 6.91V18.88C5 19.09 5.1 19.27 5.27 19.38ZM10.105 17.51C10.14 17.5225 10.175 17.535 10.21 17.55L14 19.77V6.51C13.9817 6.50391 13.9634 6.49874 13.9454 6.49366C13.9044 6.48205 13.8648 6.47086 13.83 6.45L10 4.2V17.47C10.035 17.485 10.07 17.4975 10.105 17.51ZM18.66 17.67C18.86 17.57 19 17.32 19 17.08V5.12C19 4.91 18.9 4.73 18.73 4.62C18.56 4.52 18.36 4.51 18.19 4.6L15.28 6.43C15.2011 6.47381 15.1146 6.50227 15.0338 6.52883C15.0224 6.53258 15.0111 6.53629 15 6.54V19.81L18.66 17.67Z'
    />
  </svg>
);
export default SvgMap;
